import { render, staticRenderFns } from "./PlaceContactPopup.vue?vue&type=template&id=a85f1862&scoped=true"
import script from "./PlaceContactPopup.vue?vue&type=script&lang=js"
export * from "./PlaceContactPopup.vue?vue&type=script&lang=js"
import style0 from "./PlaceContactPopup.vue?vue&type=style&index=0&id=a85f1862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85f1862",
  null
  
)

export default component.exports